const TARGET_SELECTOR = '.product-details .text-block.rte';
const CHAR_LIMIT = 125;
const EXPAND_LABEL = 'Read more';
const COLLAPSE_LABEL = 'Read less';

function walkAndTruncate(srcNode, destNode, limit, state) {
  for (const child of Array.from(srcNode.childNodes)) {
    if (state.done) return;

    if (child.nodeType === Node.TEXT_NODE) {
      const text = child.textContent;
      const remaining = limit - state.count;

      if (text.length <= remaining) {
        destNode.appendChild(document.createTextNode(text));
        state.count += text.length;
      } else {
        let cut = text.lastIndexOf(' ', remaining);
        if (cut < Math.floor(remaining * 0.6)) cut = remaining;
        destNode.appendChild(document.createTextNode(text.slice(0, cut).trimEnd()));
        state.count = limit;
        state.done = true;
      }
    } else if (child.nodeType === Node.ELEMENT_NODE) {
      const clone = child.cloneNode(false);
      destNode.appendChild(clone);
      walkAndTruncate(child, clone, limit, state);
    }
  }
}

function buildTruncatedHTML(html, limit) {
  const source = document.createElement('div');
  source.innerHTML = html;

  const dest = document.createElement('div');
  walkAndTruncate(source, dest, limit, { count: 0, done: false });

  (dest.lastElementChild || dest).appendChild(document.createTextNode('…'));
  return dest.innerHTML;
}

function init(target) {
  if (target.dataset.truncateInitialized === 'true') return;

  const plainText = (target.textContent || '').replace(/\s+/g, ' ').trim();
  if (plainText.length <= CHAR_LIMIT) return;

  target.dataset.truncateInitialized = 'true';

  const originalHTML = target.innerHTML;
  const truncatedHTML = buildTruncatedHTML(originalHTML, CHAR_LIMIT);

  const content = document.createElement('div');
  content.className = 'description-truncate__content';
  content.innerHTML = truncatedHTML;

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'description-truncate__toggle';
  button.textContent = EXPAND_LABEL;
  button.setAttribute('aria-expanded', 'false');

  let expanded = false;
  button.addEventListener('click', (event) => {
    event.preventDefault();
    expanded = !expanded;
    content.innerHTML = expanded ? originalHTML : truncatedHTML;
    button.textContent = expanded ? COLLAPSE_LABEL : EXPAND_LABEL;
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  });

  target.innerHTML = '';
  target.appendChild(content);
  target.appendChild(button);
}

function bootstrap() {
  document.querySelectorAll(TARGET_SELECTOR).forEach(init);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap, { once: true });
} else {
  bootstrap();
}

document.addEventListener('shopify:section:load', bootstrap);
